import { createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";

import DivisionsApi from "./divisions.api";

export const getListDivisionTiersRewardsAction = createAsyncThunk(
  "GET_LIST_DIVISION_TIERS_REWARDS",
  async (params, { _, rejectWithValue }) => {
    try {
      const response = await DivisionsApi.getListDivisionTiersRewards(params);

      return response;
    } catch (err) {
      notification.error({
        message: err?.message,
        duration: 5,
      });

      return rejectWithValue({ message: err?.message, error: err?.error });
    }
  }
);

export const getDivisionTiersAction = createAsyncThunk(
  "GET_DIVISION_TIERS",
  async (params, { _, rejectWithValue }) => {
    try {
      const response = await DivisionsApi.getDivisionTiers(params);

      return response;
    } catch (err) {
      notification.error({
        message: err?.message,
        duration: 5,
      });

      return rejectWithValue({ message: err?.message, error: err?.error });
    }
  }
);

export const getDivisionTiersMeAction = createAsyncThunk(
  "GET_DIVISION_TIERS_ME",
  async (params, { _, rejectWithValue }) => {
    try {
      const response = await DivisionsApi.getDivisionTiersMe(params);

      return response;
    } catch (err) {
      notification.error({
        message: err?.message,
        duration: 5,
      });

      return rejectWithValue({ message: err?.message, error: err?.error });
    }
  }
);

export const nftRewardAction = createAsyncThunk(
  "NFT_REWARD",
  async (payload, { _, rejectWithValue }) => {
    try {
      const { divisionTierNftRewardId, callback } = payload;
      const response = await DivisionsApi.nftReward({
        divisionTierNftRewardId,
      });

      if (callback) {
        callback();
      }

      return response;
    } catch (err) {
      notification.error({
        message: err?.message,
        duration: 5,
      });

      return rejectWithValue({ message: err?.message, error: err?.error });
    }
  }
);

export const getDivisionTiersHistoryAction = createAsyncThunk(
  "GET_DIVISION_TIERS_HISTORY",
  async (params, { _, rejectWithValue }) => {
    try {
      const response = await DivisionsApi.getDivisionTiersHistory(params);

      return response;
    } catch (err) {
      notification.error({
        message: err?.message,
        duration: 5,
      });

      return rejectWithValue({ message: err?.message, error: err?.error });
    }
  }
);
